import React from 'react';
import { Link } from 'react-router-dom';
import LandingLayout, { DEMO_MAILTO } from './LandingLayout';
import './SolutionsPage.css';

const CUSTOMER_DEMO_URL = 'https://home.farmersmarketspace.com';
const ADMIN_DEMO_URL = 'https://admin.farmersmarketspace.com';

const SolutionsPage = () => {
  const images = [
    {
      src: '/images/solutions/f2h_home.png',
      alt: 'Farmers Marketspace customer shop',
      label: 'Customer homepage',
      demoUrl: CUSTOMER_DEMO_URL,
    },
    {
      src: '/images/solutions/f2h_admin.png',
      alt: 'Farmers Marketspace admin panel',
      label: 'Admin homepage',
      demoUrl: ADMIN_DEMO_URL,
    },
  ];

  return (
    <LandingLayout>
      <div className="solutions-page">
        <div className="landing-container">
          <nav className="solutions-breadcrumb">
            <Link to="/">Home</Link>
            <span className="solutions-breadcrumb-sep">›</span>
            <span>Solutions</span>
          </nav>
          <h1 className="solutions-title">Solutions for Access to Fresh, Local Produce</h1>
          <p className="solutions-subtitle">
            Across the U.S., farms left behind about 14 million tons of produce in 2024—while two in three shoppers want local fruits and vegetables they often can&apos;t find, because markets aren&apos;t nearby or aren&apos;t open when they shop. Farmers Marketspace closes that gap.
          </p>

          <div className="solutions-images">
            {images.map((img) => (
              <div key={img.label} className="solutions-image-card">
                <div className="solutions-image-wrap">
                  <img src={img.src} alt={img.alt} />
                </div>
                <div className="solutions-image-footer">
                  <p className="solutions-image-label">{img.label}</p>
                  <a
                    href={img.demoUrl}
                    className="solutions-demo-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Demo
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="solutions-info">
            <h2>More Information</h2>
            <div className="solutions-info-grid">
              <div className="solutions-info-card">
                <h3><i className="fas fa-clipboard-list"></i> For Market Managers</h3>
                <ul>
                  <li>Run a 24/7 storefront with far less hands-on effort.</li>
                  <li>Access farmer accounts, help farmers get started, and stay connected.</li>
                  <li>Capture sales and customer data to grow the market.</li>
                  <li>Earn a new revenue stream from a small fee on every sale.</li>
                </ul>
              </div>
              <div className="solutions-info-card">
                <h3><i className="fas fa-tractor"></i> For Farmers</h3>
                <ul>
                  <li>Connect directly with customers looking for local food.</li>
                  <li>Control produce, manage inventory, and create packing lists.</li>
                  <li>Access sales data and brand your own space.</li>
                  <li>Easy to use from day one—from the field or the stall.</li>
                </ul>
              </div>
              <div className="solutions-info-card">
                <h3><i className="fas fa-shopping-basket"></i> For Customers</h3>
                <ul>
                  <li>Shop the market anytime—not only on market day.</li>
                  <li>Find and connect with the farmers behind your food.</li>
                  <li>Browse a branded storefront built for local produce.</li>
                  <li>Place orders simply, from any device.</li>
                </ul>
              </div>
            </div>
            <div className="solutions-features">
              <h3>Key Platform Features</h3>
              <ul>
                <li><i className="fas fa-check"></i> Branded customer storefront</li>
                <li><i className="fas fa-check"></i> Product availability & inventory management</li>
                <li><i className="fas fa-check"></i> Recurring orders & subscription management</li>
                <li><i className="fas fa-check"></i> Pick lists, packing lists & harvest lists</li>
                <li><i className="fas fa-check"></i> Order management & invoicing</li>
                <li><i className="fas fa-check"></i> Robust reporting & analytics</li>
                <li><i className="fas fa-check"></i> Web and mobile responsive</li>
              </ul>
            </div>
          </div>

          <div className="solutions-cta">
            <p>Ready to see Farmers Marketspace in action?</p>
            <a href={DEMO_MAILTO} className="landing-btn-primary landing-btn-large">
              Request a Demo
            </a>
          </div>
        </div>
      </div>
    </LandingLayout>
  );
};

export default SolutionsPage;
